module.exports = __webpack_public_path__ + "img/kl_wxqq.a33f3e58.png";